// src/actions/msalSettingModal.js

export const openMSALSettingModal = () => ({
  type: 'OPEN_MSAL_SETTING_MODAL'
});

export const closeMSALSettingModal = () => ({
  type: 'CLOSE_MSAL_SETTING_MODAL'
});
